export default {
  frenchBlue: '#006EB3',
  lightFrenchBlue: '#C7E0EF',
  coastalWaters: "#7FB6D9", // 50% frechBlue
  regalBlue: '#004977',
  beauBlue: '#B2D3E8',
  mistyBlue: '#CCE2F0',
  aliceBlue: '#E5F0F7',
  azureWhite: '#F2F8FB',
  charcoal: '#353F4C',
  slateGray: '#647790',
  cadetGray: '#95A4B7',
  mediumGray: '#E1E5EB',
  lightGray: '#F0F3F5',
  backgroundGray: '#FAFAFA',
  white: '#FFFFFF',
  lightOlivine: '#E4ECD7',
  olivine: '#94B463',
  darkOlivine: '#759E4C',
  p50Olivine: '#BACEA5',
  cabbageLeaf: '#DEE8D0',   // 30% olivine
  p10Olivine: '#F2F6ED',
  seashell: '#F8EBE8',      // 15% copperRed
  mistyRose: '#F0D6D0',     // 30% copperRed
  paleCopper: '#EACCC5',
  lightCopperRed: '#F5E2DE',
  copperRed: '#CD7865',
  darkCopperRed: '#B9533C',
  p15CopperRed: '#F4E5E1',
  lightApricot: '#F7E6D4',
  apricot: '#D98A38',
  darkApricot: '#BC7324',
  island: '#F8EEDB',        // 20% goldenrod
  champagne: '#F4E5C8',     // 30% goldenrod
  lightGoldenrod: '#F8EDD8',
  goldenrod: '#DDAB49',
  darkGoldenrod: '#BE8A23',
  lightAmethyst: '#EEE3F0',
  amethyst: '#AE7BB8',
  darkAmethyst: '#93569F',
  lightPink: '#F8E0E8',
  pink: '#DB7093',
  darkPink: '#CE3B6C',
  microsoftRed: '#F25022',
  microsoftGreen: '#7FBA00',
  microsoftBlue: '#00A4EF',
  microsoftYello: '#FFB900',
  googleBlue: '#4285F4',
  googleGreen: '#34A853',
  googleYellow: '#FBBC05',
  googleRed: '#EA4335',
  errorRed: '#991B1B',
  cyan: '#00BCD4',
  brown: '#795548',
  blueGrey: '#607D8B',
}
